let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("7EorR"), load("hhss7"), load("ffEVr"), load("3WCRn")]).then(() => parcelRequire('8IuF3'));